import uuid from 'uuid/v4';
import EVENTS from '@/utils/Constants/Events';

export default () => {
  const uuidToken = uuid();
  DLG.EVE.emit(EVENTS.SPLASH.LOADER.OPEN, uuidToken);
  return uuidToken;
};
